import React, {Fragment} from 'react';
import {Activities, Popup} from 'components';
import {modal, omit, map, moment, useNamedSelector, useLocation} from 'helpers';
import {reschedule, updateStatus} from 'store/activities';

export function StatusMenu({contextDate, activity, status, popup, nested, occurance, type, subtask, retroperspective}) {
  const { today, tomorrow } = useNamedSelector('calendar.days');
  const Container = nested ? Fragment : Popup.Menu;
  if (type == 'activity' && activity.ts) {
    contextDate = moment.unix(activity.ts);
  }
  const {pathname} = useLocation();
  const reschedulable = pathname.match(/^\/today\//);
  return (
    <Container>
      { type != 'activity' &&
        <Fragment>
          { status == 'Completed' &&
            <Popup.Menu.Item onClick={() => updateStatus({ id: activity.id, contextDate, status: 'Not Started', subtask, uncomplete: true })} icon="undo">
              Uncomplete
            </Popup.Menu.Item>
          }
          { map(omit(statuses, status), (item, name) =>
            <Popup.Menu.Item onClick={() => updateStatus({ id: activity.id, contextDate, status: name, subtask, retroperspective })} key={name} {...item} />
          ) }
        </Fragment>
      }
      { reschedulable && status != 'Completed' && type != 'subroutine' && !subtask &&
        <Fragment>
          <Popup.Menu.Separator />
          { !contextDate.isSame(today) &&
            <Popup.Menu.Item icon="due-today" onClick={() => reschedule({ id: activity.id, date: today, contextDate, occurance })}>
              Due today
            </Popup.Menu.Item>
          }
          { !contextDate.isSame(tomorrow) &&
            <Popup.Menu.Item icon="due-tomorrow" onClick={() => reschedule({ id: activity.id, date: tomorrow, contextDate, occurance })}>
              Due tomorrow
            </Popup.Menu.Item>
          }
          <Popup.Menu.Item onClick={modal(Activities.Reschedule, {activity, contextDate, occurance})} icon="pick-date">
            Reschedule
          </Popup.Menu.Item>
        </Fragment>
      }
    </Container>
  );
}

const statuses = StatusMenu.statuses = {
  Completed: {
    children: 'Complete',
    icon: 'check',
    className: 'primary'
  },
  Skipped: {
    children: 'Skip',
    icon: 'skip',
    className: 'orange'
  },
  Missed: {
    children: 'Miss',
    icon: 'close',
    className: 'danger'
  }
};
